// src/admin/hooks/useAdminWorkflows.js
import { useState, useEffect, useCallback, useRef } from 'react';
import { fetchWithAuth } from '../auth/fetchWithAuth';
import buildAdminWorkflowsQuery from './buildAdminWorkflowsQuery';
import { API_URL } from '../../config/env';

export default function useAdminWorkflows(queryString = '') {
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  // A request in flight when the component goes away must not set state on the way back. In the
  // app that is a wasted render after navigating off the page; under the test runner the
  // rejection lands after the environment is torn down, which surfaces as an unhandled error
  // ("window is not defined") and fails CI even though every test passed.
  const mountedRef = useRef(true);

  const fetchIt = useCallback(async () => {
    try {
      const qs = buildAdminWorkflowsQuery(queryString);
      const endpoint = qs
        ? `${API_URL}/v1/admin/workflows?${qs}`
        : `${API_URL}/v1/admin/workflows`;
      const res = await fetchWithAuth(endpoint);
      if (!res.ok) throw new Error(res.statusText);
      const json = await res.json();
      if (!mountedRef.current) return;
      setData(json);
      setError(null);
    } catch (err) {
      if (!mountedRef.current) return;
      console.error(err);
      setData([]);
      setError(err);
    }
  }, [queryString]);

  useEffect(() => {
    mountedRef.current = true;
    fetchIt();
    return () => { mountedRef.current = false; };
  }, [fetchIt]);

  return { data, error, refresh: fetchIt };
}
